import React from "react";
import { styled } from "styled-components";
import LogoRound from "../Svg/Icons/LogoRound";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
import { Colors } from "../../theme";

export interface Props {
  color?: keyof Colors;
  plsxPriceUsd?: number;
  showSkeleton?: boolean;
}

const PriceLink = styled.a`
  display: flex;
  align-items: center;
  svg {
    transition: transform 0.3s;
  }
  :hover {
    svg {
      transform: scale(1.2);
    }
  }
`;

const PlsxPrice: React.FC<React.PropsWithChildren<Props>> = ({
  plsxPriceUsd,
  color = "textSubtle",
  showSkeleton = true,
}) => {
  return plsxPriceUsd ? (
    <PriceLink
      href="/?outputCurrency=0x95B303987A60C71504D99Aa1b13B4DA07b0790ab"
      target="_blank"
    >
      <LogoRound width="24px" mr="8px" />
      <Text color={color} bold>{`$${plsxPriceUsd.toFixed(7)}`}</Text>
    </PriceLink>
  ) : showSkeleton ? (
    <Skeleton width={80} height={24} />
  ) : null;
};

export default React.memo(PlsxPrice);
